import type { PatternProps } from "./shared";

export function StripesPattern({ color, salt }: PatternProps) {
	/** Render */
	return (
		<defs>
			<pattern
				id={`${salt}-stripesPattern`}
				patternUnits="userSpaceOnUse"
				width="17.5"
				height="17.5"
				patternTransform="rotate(45)"
			>
				<path
					d="M0,0 L0,17.5"
					stroke={color}
					strokeWidth="7"
				/>
			</pattern>
		</defs>
	);
}
